import { render } from "./InvoiceTable.vue?vue&type=template&id=55d2465c&scoped=true"
import script from "./InvoiceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceTable.vue?vue&type=script&lang=js"

import "./InvoiceTable.vue?vue&type=style&index=0&id=55d2465c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d2465c"]])

export default __exports__